import { Component } from "react";
import moment from "moment";
import "moment-timezone";
import { Authority, ErrorX, store } from "static";
import { DOMAIN } from "config/config";
import axios from "axios";
import { Grid } from "@mui/material";
import _ from "lodash";
import ScoreCard from "./ScoreCard/ScoreCard";
import ScoreCardVar from "./ScoreCard/ScoreCardVar";
import DashboardHook from "./DashboardHook";

export interface IGPTQADashboardState {
  data: {
    DailyConv: { name: string; count: number }[];
    Overview: { title: string; values: number; remarks?: string }[];
    CustomerBehavior: { title: string; values: string | number; remarks?: string }[];
    Feedback: {
      docQueryDistribution: { name: string; value: number }[];
      likeDistribution: { name: string; value: number }[];
    };
  };
  base: {
    title: string;
    schema?: any; // not used
    titles: {
      Usage: string;
      Performance: string;
      CutomerBehaviour: string;
      Feedback: string;
    };
    graphTitles: {
      DailyCov: string;
      DocQueryDistribution: string;
      LikeDistribution: string;
    };
    url: Record<string, string>;
  };
  dateRange: {
    from: moment.Moment;
    to: moment.Moment;
  };
}

export class GPTQADashboard extends Component<{}, IGPTQADashboardState> {
  constructor(props: {}) {
    super(props);

    this.state = {
      data: {
        DailyConv: [],
        Overview: [],
        CustomerBehavior: [],
        Feedback: {
          docQueryDistribution: [],
          likeDistribution: [],
        },
      },
      base: {
        title: "",
        titles: {
          Usage: "USAGE OVERVIEW",
          Performance: "PERFORMANCE",
          CutomerBehaviour: "CUSTOMER BEHAVIOUR",
          Feedback: "FEEDBACK",
        },
        graphTitles: {
          DailyCov: "DAILY CONVERSATION",
          DocQueryDistribution: "DOCUMENTS QUERIED",
          LikeDistribution: "USER FEEDBACK",
        },
        url: {
          Info: "/Data/Analytics/GPTQADashboard",
        },
      },
      dateRange: {
        from: moment().startOf("month"),
        to: moment(),
      },
    };
  }

  componentDidMount() {
    Authority.Require("Dashboard");
    this.fetchData();
  }

  renderScoreCards(data: any[]) {
    const scoreCardItems = _.map(data, (o, i) => {
      if (i === 0 || i === 1) {
        return (
          <Grid item xs={6} lg={6} key={i} style={{ display: "flex" }}>
            <ScoreCard key={i} title={o.title} values={o.values} remarks={o.remarks}></ScoreCard>
          </Grid>
        );
      } else {
        return (
          <Grid item xs={6} lg={6} key={i} height={"100%"}>
            <ScoreCardVar key={i} title={o.title} values={o.values} remarks={o.remarks}></ScoreCardVar>
          </Grid>
        );
      }
    });
    return (
      <div className={"ScoreCards"} style={{ height: "100%" }}>
        <Grid container gap={1}>
          {scoreCardItems}
        </Grid>
      </div>
    );
  }

  onChangeDateRange(dates: [moment.Moment | null, moment.Moment | null] | null, _formatString?: [string, string]) {
    console.log("onChangeDateRange", dates);
    if (!dates || !dates[0] || !dates[1]) {
      throw new Error("Dates cannot be null");
    }
    this.setState(
      {
        dateRange: { from: moment(dates[0]).startOf("day"), to: moment(dates[1]).endOf("day") },
      },
      () => {
        this.fetchData();
      }
    );
  }

  async fetchData(): Promise<void> {
    const { base, dateRange } = this.state;
    const url = DOMAIN + base.url.Info;
    const payload = {
      JWT: store.user.JWT,
      DateRange: dateRange,
      timezone: moment.tz.guess(),
    };
    const { data } = await axios.post<{ Success: boolean; payload: IGPTQADashboardState["data"] }>(url, payload);

    if (data.Success) {
      this.setState({ data: data.payload });
    } else {
      ErrorX.Handle(data as any);
    }
  }

  render(): React.ReactNode {
    const { base, dateRange, data } = this.state;
    return <DashboardHook base={base} data={data} dateRange={dateRange} onChangeDateRange={this.onChangeDateRange.bind(this)} fetchData={this.fetchData} />;
  }
}
